import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { AutoTranslateLanguage } from '@/models/customizationModels';
import apiService from '@/services/ApiService';
import LocalDataService from '@/services/LocalDataService';

const languagesApi = createApi({
  reducerPath: 'languagesApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/' }),
  tagTypes: ['settings/languages'],

  endpoints: (builder) => ({
    getLanguages: builder.query<AutoTranslateLanguage[], void>({
      queryFn: async () => {
        try {
          const companyId = LocalDataService.getCompanyId();
          const data = await apiService.getLanguages(companyId);
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: ['settings/languages'],
    }),
  }),
});

export default languagesApi;

export const { useGetLanguagesQuery } = languagesApi;
